import { styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const ImageFlex = styled.div`
    display: flex;
`;

export const Text = styled.div`
    display: flex;
    margin-top: 16px;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    color: #040222;
    text-align: center;
`;

export const SubText = styled.div`
    display: flex;
    text-align: center;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #040222;
    margin-top: 16px;
`;

export const ButtonsRow = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    margin-top: 32px;
`;

export const ButtonWrapper = styled.div`
    display: flex;
    flex: 1;
    justify-content: center;
    margin: 0 5px;
`;
